<div ui-row uiJustify="start" uiAlign="middle">
  <button [disabled]="shouldDisableSubmitBtn" (click)="handleSubmitFeedback()" ui-button uiShape="round" uiType="primary" uiSize="large">
    {{ "submit_feedback" | localize }}
  </button>
  <button class="sp-ml-12" (click)="handleClose()" ui-button uiShape="round" uiType="link" uiSize="large">
    {{ "close" | localize }}
  </button>
</div>
